import React from 'react';
import { Carousel } from 'antd';
import FlexPicture from './FlexPicture';
import '../scss/style.scss';

const slides = [
  { icon: 'intro/slide1', name: '魔鬼鱼订货平台 — 宠物一站式进货平台首页Banner' },
  { icon: 'intro/slide2', name: '魔鬼鱼订货平台 — 单件散拿跨品牌混批无起订订货服务' },
];

const BannerCarousel = () => {
  return (
    <div className="banner-carousel-wrapper">
      <Carousel autoplay autoplaySpeed={5000} dots>
        {slides.map((slide, index) => (
          <div key={index}>
            <div className="banner-carousel-slide">
              <FlexPicture
                icon={slide.icon}
                name={slide.name}
                className="banner-carousel-img"
              />
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default BannerCarousel;